import { environment } from "../../../environments/environment";
import { Country } from "./company.config";

export const Constants = {
  DOCUMENT_TYPES: {
    DNI: 'DNI',
    PASSPORT: 'PASSPORT',
    FOREIGN_DOCUMENT: 'FOREIGN_DOCUMENT',
    RUC: 'RUC',
    OTHER: 'OTHER',
    getProps: (value?: string) => {
      const user = JSON.parse(localStorage.getItem(environment.sessionAuth)).user;
      const documents = [
        { value: 'DNI', text: user.country === Country.PERU ? 'DNI' : 'CI' },
        { value: 'PASSPORT', text: 'Pasaporte' },
        { value: 'FOREIGN_DOCUMENT', text: 'Carné de Extranjería' },
        { value: 'RUC', text: 'RUC' },
        { value: 'OTHER', text: 'OTROS' }
      ];
      if (value) {
        const document: any[] = documents.filter(x => x.value === value);
        return document ? document.find(x => x) : null;
      }
      return documents;
    }
  },
  CANCELLATION_TYPES: {
    TOTAL_CANCELLATION: 'TOTAL_CANCELLATION',
    PARTIAL_CANCELLATION: 'PARTIAL_CANCELLATION',
    getProps: () => [
      { value: 'TOTAL_CANCELLATION', text: 'Cancelación Total' },
      { value: 'PARTIAL_CANCELLATION', text: 'Cancelación Parcial' }
    ]
  },
  ADDRESS_TYPES: {
    HOME: 'HOME',
    WORK: 'WORK',
    OTHER: 'OTHER',
    getProps: () => [
      { value: 'HOME', viewValue: 'Casa / Departamento' },
      { value: 'WORK', viewValue: 'Oficina' },
      { value: 'OTHER', viewValue: 'Otros' }
    ]
  },
  FILTER_TYPES_USER_EXTERNAL: {
    SELECCIONE: 'SELECCIONE',

    DNI: 'DNI',
    TELEFONO: 'TELEFONO',
    NOMBRES: 'NOMBRE',
    APELLIDO: 'APELLIDO',
    PLACA: 'PLACA',
    ENTIDAD: 'ENTIDAD',
    getProps: () => [
      { value: 'SELECCIONE', viewValue: 'Seleccione' },
      { value: 'DNI', viewValue: 'DNI' },
      { value: 'TELEFONO', viewValue: 'Telefono' },
      { value: 'NOMBRE', viewValue: 'Nombre' },
      { value: 'APELLIDO', viewValue: 'Apellido' },
      { value: 'PLACA', viewValue: 'Placa' },
      { value: 'ENTIDAD', viewValue: 'Entidad' },
    ]
  }
};
